module.exports = __webpack_public_path__ + "img/spartan-masonry-concrete-tile-05-square.daca9b09.jpg";